import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import UserDashboardLayout from './userLayout/dashboard';
//
import UserCheckExamAnswer from './pages/student/UserCheckExamAnswer';
import AdminCheckExamAnswer from './pages/admin/AdminCheckExamAnswer';
import UserAfterSubmit from './pages/student/UserAfterSubmit';
import UserAfterSubmitPublicExam from './pages/student/UserAfterSubmitPublicExam';
import EditExam from './pages/admin/EditExam';
import UserExamList from './pages/student/UserExamList';
import UserLogin from './pages/student/UserLogin';
import UserParticipateExam from './pages/student/UserParticipateExam';
import UserParticipatePublicExam from './pages/student/UserParticipatePublicExam';
import RegisterForPublicExam from './pages/student/RegisterForPublicExam';
import AdminLogin from './pages/admin/AdminLogin';
import Institute from './pages/admin/Institute';
import ExamResult from './pages/admin/ExamResult';
import ExamDetails from './pages/admin/ExamDetails';
import OnlineExamList from './pages/admin/OnlineExamList';
import NewStudents from './pages/admin/NewStudents';
import CourseEnrollment from './pages/admin/CourseEnrollment';
import SmsSystem from './pages/admin/SmsSystem';
import BatchSummary from './pages/admin/BatchSummary';
import DynamicSmsSystem from './pages/admin/DynamicSms';
import MobileOmrUpload from './pages/student/MobileOmrUpload';
import User from './pages/student/User';
import CourseDetailsAndEnrollments from './pages/admin/CourseDetailsAndEnrollments';
import Payment from './pages/admin/Payment';
import BatchWisePaymentSummary from './pages/admin/BatchWisePaymentSummary';
import BatchWisePaymentDetails from './pages/admin/BatchWisePaymentDetails';
import Home from './pages/common/Home';
import CoolHomePage from './pages/common/CoolHomePage';
import CoolCoursePage from './pages/common/CoolCoursePage';
import Login from './pages/common/Login';
import Invoice from './pages/common/Invoice';
import NotFound from './pages/common/Page404';
import Register from './pages/student/Register';

import DashboardApp from './pages/common/DashboardApp';
import StudentInfo from './pages/admin/StudentInfo';
import UserResult from './pages/student/UserResult';
import SwitchInstituteApp from './pages/admin/SwitchInstituteApp';
import CourseList from './pages/admin/CourseList';
import AdminPrintExam from './pages/admin/AdminPrintExam';
import UserCheckFilledAnswersMobileOmr from './pages/student/UserCheckFilledAnswersMobileOmr';
import DuePayment from './pages/admin/DuePayment';
import QrCodeGeneratorPage from './pages/common/QrCodeGeneratorPage';
import OmrPointsEditor from './pages/admin/OmrPointsEditor';
import AdminRolesManager from './pages/admin/AdminRolesManager';
import InstitutionConfig from './pages/admin/InstitutionConfig';
import CoolStudentInfo from './pages/admin/CoolStudentInfo';
import CoolDashboardLayout from './layouts/coolDashboard';
import TeacherEnrollment from './pages/admin/TeacherEnrollment';
import CoolTeachersPage from './pages/common/CoolTeachersPage';
import SystemHealthMonitor from './pages/admin/SystemHealthMonitor';
import AdminRegistration from './pages/admin/AdminRegistration';
import OmrScanLogs from './pages/admin/OmrScanLogs';
import AppLogs from './pages/admin/AppLogs';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: '/dashboard',
      element: <DashboardLayout />,
      children: [
        { path: 'app', element: <DashboardApp /> },
        { path: 'switchInstitute', element: <SwitchInstituteApp /> },
        { path: 'user', element: <User /> },
        { path: 'institute', element: <Institute /> },
        { path: 'unverified/students', element: <NewStudents /> },
        { path: 'course_enrollments', element: <CourseEnrollment /> },
        { path: 'register_student', element: <StudentInfo /> },
        { path: 'cool_student_info', element: <CoolStudentInfo /> },
        { path: 'onlineExam', element: <OnlineExamList /> },
        { path: 'courseList', element: <CourseList /> },
        { path: 'batchSummary', element: <BatchSummary /> },
        { path: 'smsSystem', element: <SmsSystem /> },
        { path: 'dynamicSmsSystem', element: <DynamicSmsSystem /> },
        { path: 'examDetails', element: <ExamDetails /> },
        { path: 'examResult', element: <ExamResult /> },
        { path: 'editExam', element: <EditExam /> },
        { path: 'payment', element: <Payment /> },
        { path: 'due-payment', element: <DuePayment /> },
        { path: 'batchWisePaymentSummary', element: <BatchWisePaymentSummary /> },
        { path: 'batchWisePaymentDetails', element: <BatchWisePaymentDetails /> },
        { path: 'checkUserGivenAnswers', element: <AdminCheckExamAnswer /> },
        { path: 'courseDetailsAndEnrollments', element: <CourseDetailsAndEnrollments /> },
        { path: 'qrGeneratorPage', element: <QrCodeGeneratorPage /> },
        { path: 'omrPointsEditor', element: <OmrPointsEditor /> },
        { path: 'adminRoles', element: <AdminRolesManager /> },
        { path: 'institutionConfig', element: <InstitutionConfig /> },
        { path: 'courseView', element: <CoolCoursePage /> },
        { path: 'course-details', element: <CoolCoursePage /> },
        { path: 'teacherEnrollment', element: <TeacherEnrollment /> },
        { path: 'systemHealth', element: <SystemHealthMonitor /> },
        { path: 'adminRegistration', element: <AdminRegistration /> },
        { path: 'omrScanLogs', element: <OmrScanLogs /> },
        { path: 'appLogs', element: <AppLogs /> },
      ],
    },
    {
      path: '/cool-dashboard',
      element: <CoolDashboardLayout />,
      children: [
        { path: 'app', element: <DashboardApp /> },
        { path: 'switchInstitute', element: <SwitchInstituteApp /> },
        { path: 'user', element: <User /> },
        { path: 'institute', element: <Institute /> },
        { path: 'unverified/students', element: <NewStudents /> },
        { path: 'course_enrollments', element: <CourseEnrollment /> },
        { path: 'register_student', element: <StudentInfo /> },
        { path: 'onlineExam', element: <OnlineExamList /> },
        { path: 'courseList', element: <CourseList /> },
        { path: 'batchSummary', element: <BatchSummary /> },
        { path: 'smsSystem', element: <SmsSystem /> },
        { path: 'dynamicSmsSystem', element: <DynamicSmsSystem /> },
        { path: 'examDetails', element: <ExamDetails /> },
        { path: 'examResult', element: <ExamResult /> },
        { path: 'editExam', element: <EditExam /> },
        { path: 'payment', element: <Payment /> },
        { path: 'due-payment', element: <DuePayment /> },
        { path: 'batchWisePaymentSummary', element: <BatchWisePaymentSummary /> },
        { path: 'batchWisePaymentDetails', element: <BatchWisePaymentDetails /> },
        { path: 'checkUserGivenAnswers', element: <AdminCheckExamAnswer /> },
        { path: 'courseDetailsAndEnrollments', element: <CourseDetailsAndEnrollments /> },
        { path: 'qrGeneratorPage', element: <QrCodeGeneratorPage /> },
        { path: 'omrPointsEditor', element: <OmrPointsEditor /> },
        { path: 'adminRoles', element: <AdminRolesManager /> },
        { path: 'institutionConfig', element: <InstitutionConfig /> },
        { path: 'courseView', element: <CoolCoursePage /> },
        { path: 'course-details', element: <CoolCoursePage /> },
        { path: 'teacherEnrollment', element: <TeacherEnrollment /> },
        { path: 'systemHealth', element: <SystemHealthMonitor /> },
        { path: 'adminRegistration', element: <AdminRegistration /> },
        { path: 'omrScanLogs', element: <OmrScanLogs /> },
        { path: 'appLogs', element: <AppLogs /> },
      ],
    },
    {
      path: '/user',
      element: <UserDashboardLayout />,
      children: [
        { path: 'profile', element: <UserResult /> },
        { path: 'currentExams', element: <UserExamList /> },
        { path: 'mobileOmrScan', element: <MobileOmrUpload /> },
        { path: 'checkFilledOmrAnswers', element: <UserCheckFilledAnswersMobileOmr /> },
        { path: 'checkAnswer', element: <UserCheckExamAnswer /> },
        { path: 'afterSubmit', element: <UserAfterSubmit /> },
      ],
    },
    {
      path: '/home',
      element: <Home />,
    },
    {
      path: '/coolHomePage',
      element: <CoolHomePage />,
    },
    {
      path: '/coolCourse',
      element: <CoolCoursePage />,
    },
    {
      path: '/coolTeachers',
      element: <CoolTeachersPage />,
    },
    {
      path: 'printExam',
      element: <AdminPrintExam />,
    },
    {
      path: 'admin/login',
      element: <AdminLogin />,
    },
    {
      path: 'user/login',
      element: <UserLogin />,
    },
    {
      path: 'user/exam/participate',
      element: <UserParticipateExam />,
    },
    {
      path: 'reg/publicExam',
      element: <RegisterForPublicExam />,
    },
    {
      path: 'publicExam',
      element: <UserParticipatePublicExam />,
    },
    {
      path: 'publicExam/score',
      element: <UserAfterSubmitPublicExam />,
    },
    {
      path: 'login',
      element: <Login />,
    },
    {
      path: 'invoice',
      element: <Invoice />,
    },
    {
      path: 'user/register',
      element: <Register />,
    },
    {
      path: '/',
      // element: <LogoOnlyLayout />,
      children: [
        { path: '/', element: <Navigate to="/home" /> },
        { path: '404', element: <NotFound /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);
}
